import PropTypes from 'prop-types';
import classNames from 'classnames';

import classes from './DataGrid.module.scss';

export default function DataGrid({ fullWidth, children }) {
  return (
    <div className={classes.dataGrid}>
      <table
        cellSpacing={0}
        className={classNames({ [classes['dataGrid--fullWidth']]: fullWidth })}
      >
        {children}
      </table>
    </div>
  );
}

DataGrid.defaultProps = {
  fullWidth: false,
};

DataGrid.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
};
